import { render } from "./DiscountCodeComponent.vue?vue&type=template&id=deaf0c4e&scoped=true"
import script from "./DiscountCodeComponent.vue?vue&type=script&lang=js"
export * from "./DiscountCodeComponent.vue?vue&type=script&lang=js"

import "./DiscountCodeComponent.vue?vue&type=style&index=0&id=deaf0c4e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deaf0c4e"]])

export default __exports__